export default __webpack_public_path__ + "static/media/s4_title-summers.ca244ff8.png";